import { Flex, type FlexProps, useMultiStyleConfig } from "@chakra-ui/react";

export const StickyBar = ({ children, height, ...rest }: FlexProps) => {
	const styleParts = useMultiStyleConfig("StickyBar");

	return (
		<Flex data-testid="StickyBar" {...(styleParts.root as FlexProps)} {...rest}>
			{children}
		</Flex>
	);
};
